import React, { useContext } from 'react';
import { VehicleState } from '../CommonTypes';
import { SummaryItem } from './Summary';
import { getFormattedDate } from '../HelperMethods';
import { Journey } from '../../../consts/Common';
import {
  formatNumber,
  getCurrencySymbol,
  getDateStringByBrowserLanguage
} from '../Formatter';
import { useTranslation } from 'react-i18next';
import { SiteContext } from '../../../context/SiteContext';

export type VehicleSummaryProps = {
  vehicle: VehicleState;
  journeyType: number;
  culture: string;
};

const SummaryVehicle = ({
  vehicle,
  journeyType,
  culture
}: VehicleSummaryProps): JSX.Element => {
  const { t } = useTranslation();
  let deliveryDate = getFormattedDate(vehicle.vehicleDeliveryDate);
  deliveryDate = getDateStringByBrowserLanguage(culture, deliveryDate);
  const currencySymbol = getCurrencySymbol();
  const vehicleRegistrationDate = getDateStringByBrowserLanguage(
    culture,
    vehicle.vehicleDetails.registrationDate
  );

  const vehicleRegistrationLabel = t('summary.vehicle-registration-label');
  const makeLabel = t('summary.make-label');
  const modelLabel = t('summary.model-label');
  const modelTypeLabel = t('summary.model-type-label');
  const vehicleRegistrationDateLabel = t(
    'summary.vehicle-registration-date-label'
  );
  const currentMileageLabel = t('summary.current-mileage-label');
  const vehicleDeliveryDateLabel = t('summary.vehicle-delivery-date-label');
  const purchasePriceLabel = t('summary.purchase-price-label');
  const vehiclePurchasePriceLabel = t('summary.vehicle-purchase-price-label');
  const vehicleIdentificationLabel = t(
    'landing-page.vehicle-identification-number'
  );

  const { site } = useContext(SiteContext);
  const cms = site.content.landingPage;

  const { useVinInput } = cms;

  return (
    <div className='flex-column'>
      <SummaryItem
        label={vehicleRegistrationLabel}
        value={vehicle.vehicleDetails.vrn}
      />
      {useVinInput && (
        <SummaryItem
          label={vehicleIdentificationLabel}
          value={vehicle.vehicleDetails.vin || ''}
        />
      )}

      <SummaryItem label={makeLabel} value={vehicle.vehicleDetails.make} />
      <SummaryItem label={modelLabel} value={vehicle.vehicleDetails.model} />
      <SummaryItem
        label={modelTypeLabel}
        value={vehicle.vehicleDetails.fuelType}
      />
      <SummaryItem
        label={vehicleRegistrationDateLabel}
        value={vehicleRegistrationDate}
      />
      <SummaryItem
        label={currentMileageLabel}
        value={
          vehicle.currentMileage
            ? formatNumber(vehicle.currentMileage, 0, culture)
            : ''
        }
      />
      {journeyType === Journey.DealerJourney && (
        <SummaryItem label={vehicleDeliveryDateLabel} value={deliveryDate} />
      )}
      {(journeyType === Journey.Renewals ||
        journeyType === Journey.CallCentre) && (
        <SummaryItem
          label={purchasePriceLabel}
          value={`${currencySymbol}${formatNumber(
            vehicle.vehiclePurchasePrice,
            0,
            culture
          )}`}
        />
      )}
      {journeyType === Journey.DealerJourney && (
        <SummaryItem
          label={vehiclePurchasePriceLabel}
          value={`${currencySymbol}${formatNumber(
            vehicle.vehiclePurchasePrice,
            0,
            culture
          )}`}
        />
      )}
    </div>
  );
};

export default SummaryVehicle;
